import React from "react";
import { Box, IconButton } from "@mui/material";
import Edit from "@mui/icons-material/Edit";

import { dateFormatter } from "components/helpers";
import { getFormattedDate } from "utils/helper";

const editableFields = [
  { label: "Co-Payment (In-Network)", name: "copay_inn" },
  { label: "Co-Payment (Out-of-Network)", name: "copay_oon" },
  { label: "Deductible (In-Network)", name: "ded_inn" },
  { label: "Deductible - Remaining (In-Network)", name: "ded_remaining_inn" },
  { label: "Deductible (Out-of-Network)", name: "ded_oon" },
  { label: "Deductible Remaining (Out-of-Network)", name: "ded_remaining_oon" },
  { label: "Notes", name: "notes" },
  { label: "Coinsurance - Individual", name: "coins_ind_inn" },
  { label: "Coinsurance - Family", name: "coins_fam_inn" },
  { label: "PCP Name", name: "pcp_name" },
];

const columns = (handleEditClick) => {
  return [
    {
      field: "actions",
      headerName: "Actions",
      width: 50,
      align: "center",
      renderCell: (e) => (
        <IconButton onClick={() => handleEditClick(e.row)}>
          <Edit color="secondary" />
        </IconButton>
      ),
    },
    {
      field: "dos",
      headerName: "DOS",
      width: 100,
      align: "center",
      valueFormatter: (value) => {
        if (!value) {
          return;
        }
        return getFormattedDate(value);
      },
      valueGetter: dateFormatter,
    },
    {
      field: "patient_id",
      headerName: "Patient ID",
      width: 100,
      align: "center",
    },
    {
      field: "first_name",
      headerName: "First Name",
      width: 100,
      align: "center",
    },
    {
      field: "last_name",
      headerName: "Last Name",
      flex: 1,
      minwidth: 100,
    },
    {
      field: "id",
      headerName: "ID Number",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "payer_id",
      headerName: "Carrier ID",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "payer_name",
      headerName: "Carrier Name",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "verification_status",
      headerName: "Eligibility Status",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "notes",
      headerName: "Notes",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "copay_inn",
      headerName: "Co-Payment (In-Network)",
      flex: 3,
      width: 200,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.5em",
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "copay_oon",
      headerName: "Co-Payment (Out-of-Network))",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "ded_inn",
      headerName: "Deductible (In-Network)",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "ded_remaining_inn",
      headerName: "Deductible - Remaining (In-Network)",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "ded_oon",
      headerName: "Deductible (Out-of-Network)",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "ded_remaining_oon",
      headerName: "Deductible - Remaining (Out-of-Network)",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "coins_ind_inn",
      headerName: "Coinsurance - Individual",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "coins_fam_inn",
      headerName: "Coinsurance - Family",
      flex: 1,
      minwidth: 150,
    },
    {
      field: "pcp_name",
      headerName: "PCP Name",
      flex: 1,
      minwidth: 150,
    },
  ];
};

export { editableFields, columns };
